import styled from 'styled-components'

export const CustomComponentEmpty = styled.div`
  padding: 30px 0px 20px 0px;

  & > div {
    margin: 0 auto;
    font-size: 0.8rem;

    img {
      max-height: 100px;
    }

    p {
      margin-bottom: 12px;
    }
  }
`

export const CustomComponent = styled.div`
  padding: 1rem;
  box-sizing: border-box;
`
export const CustomComponentContent = styled.div`
  box-sizing: border-box;
`

export const CustomComponentHeader = styled.div`
  p {
    font-size: 0.85em;
    margin: 5px 0px;
  }

  button {
    display: flex;
    margin-left: auto;
  }
`
